import './assets/styles/main.css';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import { aiChecker } from '@components/AiChecker.js';

Alpine.plugin(collapse);
Alpine.data('aiChecker', aiChecker);
window.Alpine = Alpine;
Alpine.start();
